import styled from 'styled-components';
import { colors, spacing, subtleShadow } from 'ui/theme';

export const Wrapper = styled.div`
  background: ${colors.backgroundSecondary};
  padding: ${spacing.base};
  border-radius: ${spacing.half};
  box-shadow: ${subtleShadow};
`;
